<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="panel panel-primary">
        <div class="panel-heading custom-panel">
          <div class="titulo-painel-left">
            <h2>{{tituloCrud}}</h2>
          </div>
        </div>
      </div>

      <div>
        <form [formGroup]="formularioDeEspecialidade" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
          <div class="form-group">
            <mat-divider fxFlex="1 0"></mat-divider>
          </div>

          <div class="form-row">
            <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
              <mat-label>Nome</mat-label>
              <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                formControlName="nome" maxlength="60" upperCase>
              <mat-error *ngIf="formularioDeEspecialidade.controls.nome.hasError('required')">
                O campo Nome é obrigatório.
              </mat-error>
              <mat-error *ngIf="formularioDeEspecialidade.controls.nome.hasError('minlength')">
                O campo Nome precisa conter mais do que 5 caracteres.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="menu-formulario">
            <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
              <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                [disabled]="!formularioDeEspecialidade.valid">
                <mat-icon>save</mat-icon>
              </button>
            </div>
            <div class="menu-formulario-botoes">
              <botao-voltar></botao-voltar>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>